import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SitesAlertsService} from "../../../sites/services/sites-alerts.service";
import {SitesDialogService} from "../../../sites/services/sites-dialogs-service.service";
import {SitesRequestsService} from "../../../sites/services/sites-requests.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class sitePreferencesCtrl implements IController {

  site: any;

  private stateRef: any;
  private loading: boolean;
  private sideMenuOpen: any;

  /* @ngInject */
  constructor(private $state, private sitesAlertsService: SitesAlertsService, private sitesDialogService: SitesDialogService, private $log,
              private sitesRequestsService: SitesRequestsService, private confirmDialogService: ConfirmDialogService) {}

  $onInit() {
    this.stateRef = this.$state;
    this.loading = false;
    this.sideMenuOpen = {
      preferences: this.stateRef.current.name.match('preferences'),
      sms: this.stateRef.current.name.match('sms')
    };
  }

  onEditSiteInfo(event) {
    this.sitesDialogService.editSite(event, this.site)
      .then((editedSite) => {
        if (editedSite.suspended && !_.isEqual(this.site.suspended, editedSite.suspended)) {
          this._suspendSite(editedSite, event);
        } else {
          this._updateSite(editedSite);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
      .finally(() => {
        this.loading = false;
      });
  }

  _suspendSite(editedSite, event) {
    this.confirmDialogService.confirm('Suspend Site', 'Are you sure you want to suspend this site?', event)
      .then(() => {
        this._updateSite(editedSite);
      })
      .catch((error) => {
        this.$log.info(error);
      })
  }

  _updateSite(site) {
    this.loading = true;
    this.sitesRequestsService.updateSite(this.site.id, site)
      .then((updatedSite) => {
        this.site = updatedSite;
        this.sitesAlertsService.updateSuccess();
      })
      .catch((error) => {
        if (error) {
          this.sitesAlertsService.updateError();
          this.$log.error('Failed to update site @sitePreferences@onEditSiteInfo', error);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

}
angular
  .module('bringoz.admin.site-preferences')
  .component('sitePreferences', {
    bindings: {
      site: '<'
    },
    template: require('./site-preferences.html').default,
    controller: sitePreferencesCtrl
  });
